export default __webpack_public_path__ + "static/media/single-window-remediation-dlp.c646a9da.svg";